// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetLkTypeResponse {
  lkType: ELkType;
  isBuilder: boolean;
  lkDealRentSubType?: TGetLkTypeResponse_LkDealRentSubType;
}

export enum ELkType {
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Агент **/
  'Specialist' = 'specialist',
}
export type TGetLkTypeResponse_LkDealRentSubType = null | ELkDealRentSubType;

export enum ELkDealRentSubType {
  /** Арендатор в Сдай/Сними **/
  'Renter' = 'renter',
  /** Собственник в Сдай/Сними **/
  'Homeowner' = 'homeowner',
  /** Собственник и арендатор в Сдай/Сними **/
  'RenterAndHomeowner' = 'renterAndHomeowner',
}
